import { render, staticRenderFns } from "./YesterdayLevel2.vue?vue&type=template&id=ea2ec7f2&scoped=true"
import script from "./YesterdayLevel2.vue?vue&type=script&lang=js"
export * from "./YesterdayLevel2.vue?vue&type=script&lang=js"
import style0 from "./YesterdayLevel2.vue?vue&type=style&index=0&id=ea2ec7f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2ec7f2",
  null
  
)

export default component.exports